'use client';

import type { ReactNode } from 'react';
import { SignalEditModalWrapper } from '../../HITL/wrappers/SignalEditModalWrapper';
import type { EditModalProps } from '../../tool-config-types';

export const renderSignalEditModal = (props: EditModalProps): ReactNode => (
  <SignalEditModalWrapper
    isOpen={props.isOpen}
    onClose={props.onClose}
    onSubmit={props.onSubmit}
    onApprove={props.onApprove}
    onReject={props.onReject}
    toolName={props.toolName}
    extractedData={props.extractedData}
  />
);
